var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageSrc)?_c('img',{class:_vm.fieldClass,attrs:{"src":_vm.imageSrc || require('@/app/assets/img/coast.jpg')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }